import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import Loader from '@/components/Loader/index.vue'
import api from '@/helpers/fetch'

import { library } from '@fortawesome/fontawesome-svg-core'

import { faFilePdf } from '@fortawesome/free-regular-svg-icons'

library.add(faFilePdf)

@Component({
	components: {
		Loader,
	},
})
export default class Laminas extends Vue {
	@Prop({ required: true }) tags!: [number, string]
	@Prop({ required: true }) title!: string
	@Prop({ required: true }) update!: number

	laminas = [] as Array<any>

	loading = false

	@Watch('update')
	updateCount() {
		if (this.update > 0) {
			this.loadLaminas()
		}
	}

	async loadLaminas() {
		this.loading = true
		const query = [] as Array<any>

		if (this.tags.length > 0) {
			query.push('tags=' + this.tags.join(','))
		}
		if (this.title) {
			query.push('title=' + this.title)
		}

		const res = await api.get(
			'/api/blogging/content-laminas?' + query.join('&'),
		)
		this.laminas.length = 0
		this.laminas.push(...res.data)
		this.loading = false
	}
}
